import template from './product-3d-view.component.html';
var Product3dViewController = /** @class */ (function () {
    function Product3dViewController() {
    }
    Object.defineProperty(Product3dViewController.prototype, "iframeSrc", {
        get: function () {
            return "https://embed.vntana.com?productUuid=" + this.id + "&clientSlug=blue-parrott&organizationSlug=jabra&fullScreen=0&mobileARView=0&qrCode=0&centerButton=0";
        },
        enumerable: false,
        configurable: true
    });
    return Product3dViewController;
}());
export var Product3dViewComponent = {
    bindings: {
        id: '<',
    },
    template: template,
    controller: Product3dViewController,
};
